<template>
  <fieldset>
    <input
      :id="id"
      class="peer form-check"
      type="checkbox"
      v-model="modelValueComputed"
      :value="value"
      :disabled="disabled"
    />
    <label
      class="text-xs block py-1 px-2 border border-gray-300 cursor-pointer text-gray-600 rounded-md peer-checked:bg-theme-1 peer-checked:text-white peer-checked:border-theme-1 hover:bg-gray-100 hover:border-gray-100"
      :for="id"
    >
      {{ textComputed }}
    </label>
  </fieldset>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  modelValue: Array,
  value: [String, Object],
  text: String,
  id: {
    type: String,
    require: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(["update:modelValue"]);

const textComputed = computed(() => {
  if (props.text) return props.text;
  return props.value;
});
const modelValueComputed = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emits("update:modelValue", val);
  },
});
</script>

<style lang="scss" scoped>
input {
  display: none;
}
</style>
